if (!customElements.get('starter-kit-product')) {
  customElements.define(
    'starter-kit-product',
    class StarterKitProduct extends HTMLElement {
      connectedCallback() {
        this.productUrl = this.dataset.productUrl || window.location.pathname;
        this.flavorInputs = Array.from(this.querySelectorAll('[data-fe-product-flavor]'));
        this.profiles = Array.from(this.querySelectorAll('[data-fe-product-profile]'));
        this.variantInput = this.querySelector('[data-fe-product-variant-id]');
        this.formQuantityInput = this.querySelector('[data-fe-product-form-quantity]');
        this.quantityInput = this.querySelector('[data-fe-quantity-input]');
        this.price = this.querySelector('[data-fe-product-price]');
        this.submitButton = this.querySelector('.fe-starter-pdp__submit');
        this.submitText = this.querySelector('[data-fe-product-add-text]');

        this.flavorInputs.forEach((input) => {
          input.addEventListener('change', () => this.syncVariant(input, true));
          input.addEventListener('keydown', (event) => this.onFlavorKeydown(event, input));
        });

        this.querySelectorAll('[data-fe-product-accordion]').forEach((button) => {
          button.addEventListener('click', () => this.toggleAccordion(button));
        });

        this.querySelector('[data-fe-qty-minus]')?.addEventListener('click', () => this.adjustQuantity(-1));
        this.querySelector('[data-fe-qty-plus]')?.addEventListener('click', () => this.adjustQuantity(1));
        this.quantityInput?.addEventListener('change', () => this.syncQuantity());
        this.quantityInput?.addEventListener('input', () => this.syncQuantity());

        window.addEventListener('popstate', () => this.syncFromUrl(false));
        this.syncFromUrl(false);
        this.syncQuantity();
      }

      syncFromUrl(pushState) {
        const params = new URLSearchParams(window.location.search);
        const variantId = params.get('variant') || this.dataset.selectedVariantId;
        const input = this.flavorInputs.find((item) => item.dataset.variantId === variantId) || this.flavorInputs.find((item) => item.checked) || this.flavorInputs.find((item) => !item.disabled);
        if (!input) return;
        input.checked = true;
        this.syncVariant(input, pushState);
      }

      syncVariant(input, pushState) {
        const variantId = input.dataset.variantId;
        const available = input.dataset.available === 'true';

        this.profiles.forEach((profile) => {
          profile.hidden = profile.dataset.feProductProfile !== variantId;
        });

        if (this.variantInput) {
          this.variantInput.value = variantId;
          this.variantInput.disabled = !available;
        }

        if (this.price && input.dataset.price) {
          this.price.textContent = input.dataset.price;
        }

        if (this.submitButton && this.submitText) {
          this.submitButton.disabled = !available;
          this.submitText.textContent = available ? input.dataset.buttonLabel : 'Sold out';
        }

        if (pushState) {
          const nextUrl = new URL(this.productUrl, window.location.origin);
          const params = new URLSearchParams(window.location.search);
          params.set('variant', variantId);
          nextUrl.search = params.toString();
          window.history.pushState({ variantId }, '', `${nextUrl.pathname}${nextUrl.search}`);
        }
      }

      onFlavorKeydown(event, input) {
        const nextKeys = ['ArrowRight', 'ArrowDown'];
        const previousKeys = ['ArrowLeft', 'ArrowUp'];
        if (!nextKeys.includes(event.key) && !previousKeys.includes(event.key)) return;

        const enabledInputs = this.flavorInputs.filter((item) => !item.disabled);
        const currentIndex = enabledInputs.indexOf(input);
        if (currentIndex === -1 || enabledInputs.length < 2) return;

        event.preventDefault();
        const nextIndex = nextKeys.includes(event.key)
          ? (currentIndex + 1) % enabledInputs.length
          : (currentIndex - 1 + enabledInputs.length) % enabledInputs.length;
        const nextInput = enabledInputs[nextIndex];
        nextInput.checked = true;
        nextInput.focus();
        this.syncVariant(nextInput, true);
      }

      adjustQuantity(change) {
        if (!this.quantityInput) return;
        const currentValue = Number.parseInt(this.quantityInput.value, 10) || 1;
        this.quantityInput.value = Math.max(1, currentValue + change);
        this.syncQuantity();
      }

      syncQuantity() {
        if (!this.quantityInput || !this.formQuantityInput) return;
        const value = Math.max(1, Number.parseInt(this.quantityInput.value, 10) || 1);
        this.quantityInput.value = value;
        this.formQuantityInput.value = value;
      }

      toggleAccordion(button) {
        const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
        if (!panel) return;
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willOpen));
        panel.hidden = !willOpen;
      }
    }
  );
}
